<template>
    <select v-on:change="selected()" v-model="selectedValueCopy" class="mdl-shadow--2dp decorated">
        <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
    </select>
</template>

<script>
    export default {
        name: "ComboBox",
        props: {
            options: Array,
            value: String
        },
        data: function () {
          return {
              selectedValueCopy: String
          }
        },
        methods: {
            selected: function() {
                this.$emit('input', this.selectedValueCopy)
            }
        },
        watch: {
            // eslint-disable-next-line
            value: function (newVal, oldVal) {
                this.selectedValueCopy = this.value;
            }
        },
    }
</script>

<style scoped>
    select {
        border: none;
        padding: 0.25em;
    }

    select:focus {
        outline: 0;
    }
</style>